import {
  Card,
  Table,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
  TableRowProps
} from '@digdir/designsystemet-react';

import styled from '../../../../../../../styled';

export const StyledTable = styled(Table)`
  border-collapse: collapse;
  max-width: 740px;
`;

export const StyledTableCard = styled(Card)`
  padding: var(--ds-size-4);
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-2);
`;

export const StyledCaption = styled.caption`
  line-height: 130%;
  letter-spacing: 0;
  font-weight: 600;
  font-size: var(--ds-font-size-5);
  margin-bottom: var(--ds-size-4);
`;
export const StyledTableHead = styled(TableHead)`
  background: var(--ds-color-fjellgronn-surface-tinted);
`;

export const StyledTableHeaderCell = styled(TableHeaderCell)`
  border-bottom: 2px solid #b5bdbd;
  font-weight: 600;
  border-right: 1px solid #b5bdbd;
`;

export const LeftBorderCell = styled(TableCell)`
  border-left: 1px solid #b5bdbd;
`;

export const Capitalize = styled.span`
  text-transform: capitalize;
`;

interface AccentTableRowProps extends TableRowProps {
  $isSecondarySection?: boolean;
}

export const AccentedTableRow = styled(TableRow)<AccentTableRowProps>`
  border-bottom: 3px solid #b5bdbd;
  font-weight: 600;
  background: ${(props) =>
    props.$isSecondarySection ? 'var(--ds-color-fjellgronn-surface-tinted)' : `var(--ds-color-background-default)`};
`;
